const topbar = {
    docs: 'Documentos',
    help: 'Ajuda',
    subscription: 'Subscrição',
};
export default Object.freeze(topbar);
